// @TODO: proper accessible confirm plugin
/* eslint-disable no-alert */

$(() => {
  const pluginName = 'donationForm';

  $.fn[pluginName] = function Plugin(options) {
    const defaults = {
      eventUuid: null,
      locale: null,
      currency: null,
      fundraisingOrganizations: {},
      donationConfirmAmount: null,
      donorCanPayFees: null,
      routes: {
        processingFee: null,
      },
      i18n: {
        donationMessageMaximum: null,
        taxReceiptMinimum: null,
        confirmLargeDonation: null,
      },
      templates: {
        spinner: '<span class="fa fa-pulse fa-spinner" aria-hidden="true">',
      },
    };
    const settings = $.extend(true, {}, defaults, options);
    const $container = $(this);
    const elements = {
      $container,
      $spinner: $(settings.templates.spinner).clone(),
      $amount: $container.find('[data-js-amount]'),
      $amountOther: $container.find('[data-js-amount-other]'),
      $amountOtherValueContainer: $container.find('[data-js-amount-other-value-container]'),
      $amountOtherValue: $container.find('[data-js-amount-other-value]'),
      $donationFormFields: $container.find('[data-js-donation-form-fields]'),
      $fundraisingOrganizationContainer: $container.find('[data-js-fundraising-organization-container]'),
      $fundraisingOrganization: $container.find('[data-js-fundraising-organization]'),
      $fundraisingOrganizationPreselected: $container.find('[data-js-fundraising-organization-preselected]'),
      $donationChargeTotal: $container.find('[data-js-donation-charge-total]'),
      $donationFeeAbsorbed: $container.find('[data-js-donation-fee-absorbed]'),
      $donationMessageContainer: $container.find('[data-js-donor-message-container]'),
      $donationMessage: $container.find('[data-js-donor-message]'),
      $fundraisingOrganizationInfo: $container.find('[data-js-fundraising-organization-info]'),
      $fundraisingOrganizationLogo: $container.find('[data-js-fundraising-organization-logo]'),
      $fundraisingOrganizationName: $container.find('[data-js-fundraising-organization-name]'),
      $fundraisingOrganizationDescription: $container.find('[data-js-fundraising-organization-description]'),
      $fundraisingOrganizationQuestions: $container.find('[data-js-donation-organization-questions]'),
      $donationAnonymous: $container.find('[data-js-donation-anonymous]'),
      $donorNameContainer: $container.find('[data-js-donor-name-container]'),
      $donorName: $container.find('[data-js-donor-name]'),
      $taxReceiptContainer: $container.find('[data-js-tax-receipt-container]'),
      $taxReceipt: $container.find('[data-js-tax-receipt]'),
      $taxReceiptForcedText: $container.find('[data-js-tax-receipt-forced-text]'),
      $taxReceiptOptionalText: $container.find('[data-js-tax-receipt-optional-text]'),
      $taxReceiptMinimumText: $container.find('[data-js-tax-receipt-minimum-text]'),
      $taxReceiptNotApprovedText: $container.find('[data-js-tax-receipt-not-approved-text]'),
    };
    const classes = {
      active: 'active',
      hidden: 'hidden',
    };
    const state = {
      donationAmount: 0,
      donationTotal: 0,
      fundraisingOrganization: null,
    };
    const numberFormat = new Intl.NumberFormat([settings.locale], {
      style: 'currency',
      currency: settings.currency,
    });
    const requests = {
      processingFee: null,
    };

    /**
     * Store the donation amount in state
     * @param which
     * @param amount
     */
    const storeDonationAmount = (which, amount) => {
      $.extend(state, { [which]: parseFloat(amount) });
    };

    /**
     * Gets the donation amount regardless of whether it's from pre-determined checkboxes or custom
     * input
     * @returns {number}
     */
    const determineDonationAmount = () => {
      const $checkedAmount = elements.$amount.filter(':checked');

      if (!$checkedAmount.length) {
        return 0;
      }

      const checkedAmount = $checkedAmount.val();

      if (checkedAmount === 'other') {
        return elements.$amountOtherValue.val() || 0;
      }

      return checkedAmount || 0;
    };

    /**
     * Returns the donation amount or donation total after fees if applicable
     * @returns {number}
     */
    const getDonationTotal = () => {
      if (!settings.donorCanPayFees) {
        return state.donationAmount || 0;
      }

      if (elements.$donationFeeAbsorbed.is(':checked')) {
        return state.donationTotal || 0;
      }

      return state.donationAmount || 0;
    };

    /**
     * Updates the donation total in the absorb fee box
     */
    const updateDonationTotal = () => {
      if (!settings.donorCanPayFees) {
        return;
      }

      elements.$donationChargeTotal.text(numberFormat.format(getDonationTotal()));
    };

    /**
     * Decides whether to enable the tax receipt checkbox based on whether the tax receipt minimum
     * is met
     */
    const toggleTaxReceiptViaMinimum = () => {
      if (!state.fundraisingOrganization) {
        return;
      }

      const {
        minimumAmount,
        forceTaxReceipt,
      } = state.fundraisingOrganization.taxReceiptSettings;

      if (forceTaxReceipt) {
        return;
      }

      if (!minimumAmount) {
        return;
      }

      if (minimumAmount > getDonationTotal()) {
        elements.$taxReceipt
          .prop('checked', false)
          .prop('disabled', true);
      } else {
        elements.$taxReceipt.prop('disabled', false);
      }
    };

    /**
     * Asks the server what the fees would be
     */
    const getFeeCalculation = () => {
      if (!settings.donorCanPayFees) {
        return;
      }

      if (!state.donationAmount) {
        return;
      }

      // we clear the donation total if the donation amount changes, so if it's non zero, it means
      // the user just changed the absorb checkbox, so just use what we already have store
      // instead of trying to grab it again from the server
      if (state.donationTotal) {
        updateDonationTotal();
        return;
      }

      const fundraisingOrganization = elements.$fundraisingOrganization.val();

      if (!fundraisingOrganization) {
        return;
      }

      if (requests.processingFee) {
        requests.processingFee.abort();
        requests.processingFee = null;
      }

      if (!elements.$donationFeeAbsorbed.is(':checked')) {
        updateDonationTotal();
        return;
      }

      elements.$donationChargeTotal.html(elements.$spinner.clone());

      requests.processingFee = $.ajax({
        url: settings.routes.processingFee,
        type: 'post',
        dataType: 'json',
        data: {
          event: settings.eventUuid,
          fundraising_organization: fundraisingOrganization,
          amount: state.donationAmount,
        },
      })
        .done((response) => {
          storeDonationAmount('donationTotal', parseFloat(response.combinedAsFloat));
          updateDonationTotal();
          toggleTaxReceiptViaMinimum();
        })
        .always(() => {
          requests.processingFee = null;
        });
    };

    /**
     * Only show the form fields if a donation amount AND fundraising org is selected
     */
    const toggleFormFields = () => {
      if (!state.fundraisingOrganization) {
        return;
      }

      if (!elements.$amount.filter(':checked').length) {
        return;
      }

      elements.$donationFormFields.removeClass(classes.hidden);
    };

    /**
     * Shows or hides the custom donation input
     */
    const amountChange = () => {
      const $checkedAmount = elements.$amount.filter(':checked');
      const checkedAmount = $checkedAmount.length ? $checkedAmount.val() : 0;

      storeDonationAmount('donationTotal', 0);

      if (checkedAmount === 'other') {
        elements.$amountOtherValueContainer.removeClass(classes.hidden);
        elements.$amountOtherValue
          .prop('disabled', false)
          .prop('required', true);
      } else {
        elements.$amountOtherValueContainer.addClass(classes.hidden);
        elements.$amountOtherValue
          .val('')
          .prop('disabled', true)
          .prop('required', false);
      }
    };

    /**
     * Moves the max length message below the textarea
     */
    const moveMaxlengthMessage = () => {
      const { $donationMessage } = elements;
      const top = parseInt($donationMessage.top, 10) + parseInt($donationMessage.height, 10) + 5;
      $('span.bootstrap-maxlength').css('top', top);
    };

    /**
     * Gets the info for the selected fundraising organization
     * @returns {null|*}
     */
    const getSelectedFundraisingOrganization = () => {
      const fundraisingOrganizationUuid = elements.$fundraisingOrganization.val();

      if (!fundraisingOrganizationUuid) {
        return null;
      }

      if (!(fundraisingOrganizationUuid in settings.fundraisingOrganizations)) {
        return null;
      }

      return settings.fundraisingOrganizations[fundraisingOrganizationUuid];
    };

    /**
     * Does all the weird wigglies for when there is a tax receipt
     */
    const setupTaxReceiptMinimum = () => {
      if (!state.fundraisingOrganization) {
        return;
      }

      const { minimumAmount } = state.fundraisingOrganization.taxReceiptSettings;

      if (!minimumAmount) {
        elements.$taxReceiptMinimumText.addClass(classes.hidden);
        return;
      }

      const minimumAmountText = settings.i18n.taxReceiptMinimum
        .replace('%minimumAmount%', numberFormat.format(minimumAmount));

      elements.$taxReceiptMinimumText
        .text(minimumAmountText)
        .removeClass(classes.hidden);

      toggleTaxReceiptViaMinimum();
    };

    /**
     * Gets the tax receipt info and updates all the taxxy things
     */
    const loadTaxReceiptInfo = () => {
      const { fundraisingOrganization } = state;

      if (!fundraisingOrganization) {
        return;
      }

      const {
        forceTaxReceipt,
        isApproved,
        isDisplayed,
      } = fundraisingOrganization.taxReceiptSettings;

      if (!isDisplayed) {
        elements.$taxReceiptContainer.addClass(classes.hidden);
        elements.$taxReceipt.prop('disabled', true);
        return;
      }

      elements.$taxReceiptContainer.removeClass(classes.hidden);
      elements.$taxReceipt.prop('disabled', false);

      if (forceTaxReceipt) {
        elements.$taxReceipt
          .prop('checked', true)
          .prop('disabled', true);
        elements.$taxReceiptForcedText.removeClass(classes.hidden);
        elements.$taxReceiptOptionalText.addClass(classes.hidden);
      } else {
        elements.$taxReceipt.prop('disabled', false);
        elements.$taxReceiptForcedText.addClass(classes.hidden);
        elements.$taxReceiptOptionalText.removeClass(classes.hidden);
        setupTaxReceiptMinimum();
      }

      if (isApproved) {
        elements.$taxReceiptNotApprovedText.addClass(classes.hidden);
      } else {
        elements.$taxReceiptNotApprovedText.removeClass(classes.hidden);
      }
    };

    /**
     * Gets and shows all the info for the selected fundraising organization
     */
    const toggleFundraisingOrganizationInfo = () => {
      if (!elements.$fundraisingOrganizationInfo.length) {
        return;
      }

      const { fundraisingOrganization } = state;

      if (!fundraisingOrganization) {
        return;
      }

      if (!elements.$amount.filter(':checked').length) {
        return;
      }

      elements.$fundraisingOrganizationName.html($('<span />').text(fundraisingOrganization.name).html());
      elements.$fundraisingOrganizationDescription.html(fundraisingOrganization.description);

      if (fundraisingOrganization.logo) {
        elements.$fundraisingOrganizationLogo
          .attr('src', fundraisingOrganization.logo)
          .removeClass(classes.hidden);
      } else {
        elements.$fundraisingOrganizationLogo.addClass(classes.hidden);
      }

      elements.$fundraisingOrganizationInfo.removeClass(classes.hidden);
    };

    /**
     * Toggle questions for the selected fundraising organization
     */
    const toggleFundraisingOrganizationQuestions = () => {
      if (!elements.$fundraisingOrganizationQuestions.length) {
        return;
      }

      const { fundraisingOrganization } = state;

      if (!fundraisingOrganization) {
        return;
      }

      if (fundraisingOrganization.hasQuestions) {
        elements.$fundraisingOrganizationQuestions
          .html(elements.$fundraisingOrganizationQuestions
            .html()
            .replace(/__FUNDRAISING_ORGANIZATION_NAME__/g, fundraisingOrganization.name))
          .removeClass(classes.hidden);
      } else {
        elements.$fundraisingOrganizationQuestions.addClass(classes.hidden);
      }
    };

    /**
     * Checks a few things before allowing submission
     * @param event
     */
    const submit = (event) => {
      if (!elements.$container[0].checkValidity()) {
        return;
      }

      event.preventDefault();

      const amount = getDonationTotal();
      const donationConfirmAmount = parseInt(settings.donationConfirmAmount, 10);

      if (donationConfirmAmount !== 0 && amount >= donationConfirmAmount) {
        const warning = settings.i18n.confirmLargeDonation
          .replace('%donationAmount%', numberFormat.format(amount));

        if (!window.confirm(warning)) {
          elements.$container.trigger('raceRoster.preventDoubleSubmission.reEnable');
          return;
        }
      }

      elements.$container
        .off(`submit.${pluginName}`)
        .trigger('submit');
    };

    const donationFeeAbsorbedUpdate = (event) => {
      if (!settings.donorCanPayFees) {
        return;
      }

      if ($(event.currentTarget).is(':checked')) {
        getFeeCalculation();
        return;
      }

      updateDonationTotal();
    };

    const toggleFundraisingOrganization = () => {
      if (!elements.$fundraisingOrganizationContainer) {
        return;
      }

      if (!elements.$amount.filter(':checked').length) {
        return;
      }

      elements.$fundraisingOrganizationContainer.removeClass(classes.hidden);
    };

    const updateCallToActionHeader = () => {
      const selectedFundraisingOrganization = getSelectedFundraisingOrganization();
      const $callToActionHeader = $('[data-js-call-to-action-header]');
      const text = $callToActionHeader
        .attr('data-js-string')
        .replace('%charityName%', selectedFundraisingOrganization.name);

      $callToActionHeader.text(text);
    };

    /**
     * Fires up
     */
    const initialize = () => {
      elements.$donationMessage.maxlength({
        threshold: 50,
        message: settings.i18n.donationMessageMaximum,
        utf8: true,
      });

      elements.$donationMessage.on('maxlength.shown', moveMaxlengthMessage);
      elements.$amount.on('change', () => {
        storeDonationAmount('donationAmount', determineDonationAmount());
        amountChange();
        toggleFormFields();
        getFeeCalculation();
        toggleFundraisingOrganization();
        toggleFundraisingOrganizationInfo();
        toggleTaxReceiptViaMinimum();
      });
      elements.$amountOther.on('change', () => {
        setTimeout(() => {
          elements.$amountOtherValue.trigger('focus');
        });
      });
      elements.$amountOtherValue.on('change', () => {
        storeDonationAmount('donationAmount', determineDonationAmount());
        amountChange();
        getFeeCalculation();
        toggleTaxReceiptViaMinimum();
      });
      elements.$amountOtherValue.on('scroll', (event) => {
        event.preventDefault();
      });
      elements.$fundraisingOrganization.on('change', () => {
        $.extend(state, { fundraisingOrganization: getSelectedFundraisingOrganization() });
        toggleFundraisingOrganizationInfo();
        toggleFundraisingOrganizationQuestions();
        loadTaxReceiptInfo();
        toggleFormFields();
        getFeeCalculation();
        updateCallToActionHeader();
      });

      elements.$container.on(`submit.${pluginName}`, submit);
      elements.$donationFeeAbsorbed.on('change', donationFeeAbsorbedUpdate);

      amountChange();

      if (elements.$fundraisingOrganizationPreselected.length) {
        $.extend(state, { fundraisingOrganization: getSelectedFundraisingOrganization() });
        toggleFundraisingOrganizationInfo();
        loadTaxReceiptInfo();
      }
    };

    initialize();

    return this;
  };
});
